// extracted by mini-css-extract-plugin
export default {"container":"AboutGarudaBackgroundImage_container__PEJfJ","childContainer":"AboutGarudaBackgroundImage_childContainer__CS5HM"};